module.exports = __webpack_public_path__ + "media/images/countryrect/mu-4f2033ca58589532c08c809c1381b1a1.svg";